<style>
	 @import '@/assets/css/custom.css';
	 
	 .hover-bg-light:hover {
		 background-color: #f8f9fa !important;
	 }
	 
	 .cursor-pointer {
		 cursor: pointer;
	 }
</style>

<template>
    <div>
        <Breadcrumbs main="Boards" title="Boards" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<!-- <div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<button class="btn btn-primary float-end" type="button" data-original-title="test" @click="openAddBoardModal">Add Board</button>
									</div>
								</div>
							</div> -->

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-4 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="onFilterChange">
												<option value="10">10</option>
												<option value="20">20</option>
												<option value="50">50</option>
												<option value="100">100</option>
												<option value="200">200</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="sort_by" @change="onFilterChange">
											<option value="">Sort By</option>
											<option value="1">Serial Number</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="onFilterChange">
											<option value="">Board Status</option>
											<option value="1">Pending</option>
											<option value="2">Completed</option>
											<option value="3">To Vendor</option>
											<option value="4">Enclosure Pending</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="firmware_status" @change="onFilterChange">
											<option value="">Firmware Status</option>
											<option value="1">Pending</option>
											<option value="2">Firmware Success</option>
											<option value="3">Firmware Failed</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="onSearchInput"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Vendor Name</th>
											<th>Board Number <br> Serial Number</th>
											<th>IMEI & ICCID</th>
											<th>Firmware Status</th>
											<th>Board Status</th>
											<th>Firmware By</th>
											<th>Enclosure By</th>
											<th>Updated On</th>
											<th>Action</th> 
                                        </tr>
									</thead>
									<tbody v-if="Boolean(boards.length)">
                                        <tr v-for="(board, index) in boards" :key="board.id" align="center">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ board.vendor_name }}</td>
											<td>{{ board.board_number }}
												<br>{{ board.serial_number }}
												<br>{{ board.batch_number }}
											</td>
                                            <td>{{ board.imei }}
												<br>{{ board.iccid }}
											</td>
                                            <td>
												<span v-if="board.firmware_status == 1">
													<span class="badge rounded-pill bg-info">Pending</span>
												</span>
												<span v-if="board.firmware_status == 2">
													<span class="badge rounded-pill bg-success">Firmware Success</span>
												</span>
												<span v-if="board.firmware_status == 3">
													<span class="badge rounded-pill bg-danger">Firmware Failed</span>
												</span>
											</td>
											<td>
												<span v-if="board.status == 1">
													<span class="badge rounded-pill bg-warning">Pending</span>
												</span>
												<span v-if="board.status == 2">
													<span class="badge rounded-pill bg-success">Completed</span>
												</span>
												<span v-if="board.status == 3">
													<span class="badge rounded-pill bg-secondary">To Vendor</span>
												</span>
												<span v-if="board.status == 4">
													<span class="badge rounded-pill bg-info">Enclosure Pending</span>
												</span>
											</td>
											<td>{{ board.firmware_success_user_name }}
												<br>{{ board.firmware_success_date }}
											</td>
											<td>{{ board.enclosure_user_name }}
												<br>{{ board.enclosure_date }}
											</td>
                                            <td>{{ $filters.formatDate(board.updated_at) }}</td>
                                            <td>
												<router-link :to="{ name: 'board_info', params: { id: board.id }, query: $route.query }" class="btn btn-outline-secondary btn-sm me-2 mb-2">Details</router-link>
												<router-link v-if="board.firmware_status == 3" :to="{ name: 'board_detail', params: { id: board.id }, query: $route.query }" class="btn btn-primary btn-sm me-2 mb-2">Update</router-link>
												<div v-if="board.firmware_status == 1">
													<button class="btn btn-success btn-sm me-2 mb-2" @click="openModal(board.id)">Firmware Success</button>
													<button class="btn btn-danger btn-sm me-2 mb-2" @click="openFirmwareFailedModal(board)">Firmware Failed</button>
												</div>
												<div v-if="board.firmware_status == 2">
													<button class="btn btn-info btn-sm me-2 mb-2" @click="openUpdateSerialModal(board)">Update Serial Number</button>
												</div>
                                            </td>
                                        </tr>
                                      
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(boards.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchBoards(page.url + '&limit=' + listing_length + '&status=' + status + '&firmware_status=' + firmware_status + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal title="Firmware Update">
			<template #body>
				<form @submit.prevent="markBoardFirmwareSuccess" enctype="multipart/form-data">
					<!-- Current Batch Information -->
					<div class="row" v-if="currentBatch">
						<div class="col-md-12">
							<div class="alert alert-info">
								<strong>Current Batch:</strong> {{ currentBatch.batch_number }}<br>
								<strong>Total Boards:</strong> {{ currentBatch.total_boards }}
							</div>
							<button type="button" class="btn btn-success btn-sm mb-3" @click="createNewBatch">Start New Batch</button>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12 form-group mt-2">
                            <label class="control-label">Device Model<span class="text-danger">*</span></label>
                        	<select v-model="device_model_id" class="form-select" required>
								<option value="">Select Device Model</option>
								<option v-for="model in deviceModels" :key="model.id" :value="model.id">{{ model.modelName }}</option>
							</select>
                        </div>
					</div>
					<div class="row">
						<div class="col-md-12 form-group mt-2">
                            <label class="control-label">IMEI<span class="text-danger">*</span></label>
                        	<input v-model="imei" class="form-control" rows="3"/>
                        </div>
					</div>
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Select ICCID<span class="text-danger">*</span></label>
                        	<div class="position-relative">
								<input 
									v-model="iccid_search" 
									class="form-control" 
									placeholder="Search ICCID..."
									@input="searchIccid"
									@focus="showIccidSuggestions = true"
									@blur="hideIccidSuggestions"
								/>
								<div v-if="showIccidSuggestions && filteredIccidList.length > 0" class="position-absolute w-100 bg-white border rounded shadow-sm" style="z-index: 1000; max-height: 200px; overflow-y: auto;">
									<div 
										v-for="iccid in filteredIccidList" 
										:key="iccid.id"
										class="p-2 border-bottom cursor-pointer hover-bg-light"
										@click="selectIccid(iccid)"
										style="cursor: pointer;"
									>
										{{ iccid.iccid }}
									</div>
								</div>
							</div>
                        </div>
                    </div>

					<div class="row" v-if="selectedIccid">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">SIM 1<span class="text-danger">*</span></label>
                        	<input v-model="selectedIccid.msisdn_1" class="form-control" disabled/>
                        </div>
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">SIM 2<span class="text-danger">*</span></label>
                        	<input v-model="selectedIccid.msisdn_2" class="form-control" disabled/>
                        </div>
                    </div>

					<div class="row">
						<div class="col-md-12 form-group mt-2">
							<label class="control-label">Firmware Version<span class="text-danger">*</span></label>
                        	<select v-model="firmware_version" class="form-select">
								<option value="">Select</option>
								<option value="AWNVer 6.49.2+494">AWNVer 6.49.2+494</option>
							</select>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12 form-group mt-2">
							<button type="submit" class="btn btn-primary me-3" :disabled="isSubmittingFirmwareSuccess">
								<span v-if="isSubmittingFirmwareSuccess" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
								{{ isSubmittingFirmwareSuccess ? 'Saving...' : button_title }}
							</button>
							<button class="btn btn-light" type="button" :disabled="isSubmittingFirmwareSuccess" @click="closeModal()">Close</button>
						</div>
					</div>
				</form>
			</template>
		</DynamicModal>

		<!-- Add Board Modal -->
		<div class="modal fade" id="addBoardModal" tabindex="-1" aria-labelledby="addBoardModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="addBoardModalLabel">Add Board</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="addBoard" enctype="multipart/form-data">
							<div class="row">
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Vendor<span class="text-danger">*</span></label>
									<select v-model="newBoard.vendor" class="form-select" required>
										<option value="">Select Vendor</option>
										<option v-for="vendor in vendors" :key="vendor.id" :value="vendor.id">
											{{ vendor.name }}
										</option>
									</select>
									<span v-if="errors.vendor" class="text-danger small">{{ errors.vendor }}</span>
								</div>
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Invoice Number<span class="text-danger">*</span></label>
									<input v-model="newBoard.invoice_number" type="text" class="form-control" placeholder="Enter invoice number" required />
									<span v-if="errors.invoice_number" class="text-danger small">{{ errors.invoice_number }}</span>
								</div>
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Amount<span class="text-danger">*</span></label>
									<input v-model="newBoard.amount" type="number" class="form-control" min="0" step="0.01" placeholder="Enter amount" required />
									<span v-if="errors.amount" class="text-danger small">{{ errors.amount }}</span>
								</div>
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Count<span class="text-danger">*</span></label>
									<input v-model="newBoard.count" type="number" class="form-control" min="1" placeholder="Enter count" required />
									<span v-if="errors.count" class="text-danger small">{{ errors.count }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 form-group mt-3">
									<button type="submit" class="btn btn-primary me-3" :disabled="board_loading">
										<span v-if="board_loading">Saving...</span>
										<span v-else>Save Board</span>
									</button>
									<button type="button" class="btn btn-light" @click="closeAddBoardModal">Close</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<!-- Update Serial Number Modal -->
		<div class="modal fade" id="updateSerialModal" tabindex="-1" aria-labelledby="updateSerialModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="updateSerialModalLabel">Update Serial Number</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="updateSerialNumber" enctype="multipart/form-data">
							<div class="row">
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">IMEI</label>
									<input v-model="selectedBoardForSerialUpdate.imei" class="form-control" disabled/>
								</div>
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Current Serial Number</label>
									<input v-model="selectedBoardForSerialUpdate.serial_number" class="form-control" disabled/>
								</div>
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Device Model<span class="text-danger">*</span></label>
									<select v-model="serialUpdateDeviceModelId" class="form-select" required>
										<option value="">Select Device Model</option>
										<option v-for="model in deviceModels" :key="model.id" :value="model.id">{{ model.modelName }}</option>
									</select>
								</div>
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">New Serial Number<span class="text-danger">*</span></label>
									<div class="input-group">
										<span class="input-group-text bg-light" style="min-width: 7ch; font-family: monospace;">{{ serialPrefix }}</span>
										<input v-model="serialSuffix" type="text" class="form-control" placeholder="Enter suffix (editable part)" :disabled="!serialUpdateDeviceModelId" />
									</div>
									<small class="text-muted">First 7 characters (prefix) are from the selected device model and cannot be edited.</small>
									<span v-if="errors.serial_number" class="text-danger small d-block">{{ errors.serial_number }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 form-group mt-3">
									<button type="submit" class="btn btn-primary me-3" :disabled="isSubmittingSerial">
										<span v-if="isSubmittingSerial">Saving...</span>
										<span v-else>Save</span>
									</button>
									<button type="button" class="btn btn-light" @click="closeUpdateSerialModal">Close</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<!-- Firmware Failed Modal -->
		<div class="modal fade" id="firmwareFailedModal" tabindex="-1" aria-labelledby="firmwareFailedModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="firmwareFailedModalLabel">Firmware Failed</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="submitFirmwareFailure" enctype="multipart/form-data">
							<div class="row">
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">IMEI</label>
									<input v-model="failedBoardImei" class="form-control"/>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Device Model</label>
									<select v-model="failedDeviceModelId" class="form-select">
										<option value="">Select Device Model (optional)</option>
										<option v-for="model in deviceModels" :key="model.id" :value="model.id">{{ model.modelName }}</option>
									</select>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Select ICCID</label>
									<div class="position-relative">
										<input
											v-model="failedIccidSearch"
											class="form-control"
											placeholder="Search ICCID... (optional)"
											@input="searchIccidFailed"
											@focus="failedShowIccidSuggestions = true"
											@blur="hideIccidSuggestionsFailed"
										/>
										<div v-if="failedShowIccidSuggestions && failedFilteredIccidList.length > 0" class="position-absolute w-100 bg-white border rounded shadow-sm" style="z-index: 1000; max-height: 200px; overflow-y: auto;">
											<div
												v-for="iccid in failedFilteredIccidList"
												:key="iccid.id"
												class="p-2 border-bottom cursor-pointer hover-bg-light"
												@click="selectIccidFailed(iccid)"
												style="cursor: pointer;"
											>
												{{ iccid.iccid }}
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row" v-if="failedSelectedIccid">
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">SIM 1</label>
									<input v-model="failedSelectedIccid.msisdn_1" class="form-control" disabled/>
								</div>
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">SIM 2</label>
									<input v-model="failedSelectedIccid.msisdn_2" class="form-control" disabled/>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 form-group mt-3">
									<button type="submit" class="btn btn-danger me-3" :disabled="isSubmittingFirmwareFailure">
										<span v-if="isSubmittingFirmwareFailure" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										<span v-if="isSubmittingFirmwareFailure">Saving...</span>
										<span v-else>Mark Firmware Failed</span>
									</button>
									<button type="button" class="btn btn-light" :disabled="isSubmittingFirmwareFailure" @click="closeFirmwareFailedModal">Close</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Board Page",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

		data() {
			return {
				
				modal_title: "Add Board",
				button_title: "Save",
				board_id: "",
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},

                vendor: "",
				stock: "",
				imei: "",
				iccid_search: "",
				selectedIccid: null,
				showIccidSuggestions: false,
				filteredIccidList: [],
				status: "",
				firmware_status: "",
				loading: false,
				iccid_list: [],
				newBoard: {
					vendor: "",
					count: "",
					invoice_number: "",
					amount: "",
				},
				vendors: [],
				firmware_version: "",

				boards: [],

				pagination: {},
				from: 0,
				to: 0,
				total: 0,
				active_page_url: null,
				current_page: 1,
				currentBatch: null,
				deviceModels: [],
				device_model_id: "",
				selectedBoardForSerialUpdate: {
					id: null,
					imei: "",
					serial_number: "",
					device_model_id: null
				},
				serialUpdateDeviceModelId: "",
				serialSuffix: "",
				isSubmittingSerial: false,
				// Firmware Failed modal
				failedBoardId: null,
				failedBoardImei: "",
				failedIccidSearch: "",
				failedSelectedIccid: null,
				failedDeviceModelId: "",
				failedShowIccidSuggestions: false,
				failedFilteredIccidList: [],
				isSubmittingFirmwareFailure: false,
				isSubmittingFirmwareSuccess: false,

				board_loading: false,
				searchDebounceTimer: null,
				sort_by: "",
				refreshIntervalId: null,
			};
		},
		computed: {
			serialPrefix() {
				if (!this.serialUpdateDeviceModelId) return "";
				const model = this.deviceModels.find(m => m.id == this.serialUpdateDeviceModelId);
				if (!model) return "";
				const combined = (model.manufacturer || "") + (model.model || "") + (model.test_agency || "");
				return combined.substring(0, 7).padEnd(7);
			},
		},
		created() {
			this.applyRouteQuery();
			const initialUrl = this.buildBoardsUrl(this.current_page);
			this.active_page_url = initialUrl;
			this.fetchBoards(initialUrl);
			this.fetchVendors();
			this.fetchIccidList();
			this.fetchDeviceModels();
			this.startBoardsAutoRefresh();
		},
		beforeUnmount() {
			this.clearBoardsAutoRefresh();
		},
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},
			
			buildBoardsUrl(page) {
				return "/staffs/airoBoards?page=" + (page || 1) + "&limit=" + this.listing_length + "&status=" + this.status + "&firmware_status=" + this.firmware_status + "&keyword=" + encodeURIComponent(this.keyword || "") + "&sort_by=" + this.sort_by;
			},

			applyRouteQuery() {
				const q = this.$route.query;
				if (q.page) this.current_page = parseInt(q.page, 10) || 1;
				if (q.limit) this.listing_length = q.limit;
				if (q.status !== undefined) this.status = q.status;
				if (q.firmware_status !== undefined) this.firmware_status = q.firmware_status;
				if (q.sort_by !== undefined) this.sort_by = q.sort_by;
			},

			syncRouteQuery() {
				// If the component is still mounted but the user navigated away,
				// do not force-redirect back to the boards page.
				if (this.$route && this.$route.name !== "boards") return;

				let page = this.current_page;
				try {
					if (this.active_page_url) {
						const match = /[?&]page=(\d+)/.exec(this.active_page_url);
						if (match) page = parseInt(match[1], 10);
					}
				} catch (e) {}
				this.current_page = page;
				this.$router.replace({
					name: "boards",
					query: {
						page: page,
						limit: this.listing_length,
						status: this.status,
						firmware_status: this.firmware_status,
						sort_by: this.sort_by
					}
				});
			},

			onSearchInput() {
				if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
				this.searchDebounceTimer = setTimeout(() => {
					this.current_page = 1;
					this.fetchBoards();
					this.searchDebounceTimer = null;
				}, 400);
			},

			onFilterChange() {
				this.current_page = 1;
				this.fetchBoards();
			},

			fetchBoards(page_url = null, skipSync = false) {
				this.getToken();
				let url = this.buildBoardsUrl(this.current_page);
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.boards = responseData.airoBoards.data;
						this.pagination = responseData.airoBoards.links;
						this.from = responseData.airoBoards.from;
						this.to = responseData.airoBoards.to;
						this.total = responseData.airoBoards.total;
						if (!skipSync) this.syncRouteQuery();
					})
					.catch((err) => console.log(err));
			},

			startBoardsAutoRefresh() {
				this.clearBoardsAutoRefresh();
				this.refreshIntervalId = setInterval(() => {
					// Keep refreshing the currently active page & filters (active_page_url is updated by fetchBoards)
					if (this.active_page_url) {
						this.fetchBoards(this.active_page_url, true);
					} else {
						this.fetchBoards(this.buildBoardsUrl(this.current_page), true);
					}
				}, 15000);
			},

			clearBoardsAutoRefresh() {
				if (this.refreshIntervalId) {
					clearInterval(this.refreshIntervalId);
					this.refreshIntervalId = null;
				}
			},

			fetchVendors() {
				this.getToken();
				this.$axios
					.get("/staffs/vendorsList", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.vendors = responseData.data;
					})
					.catch((err) => console.log(err));
			},

			fetchIccidList() {
				this.getToken();
				this.$axios
					.get("/staffs/getAvailableSimList", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.iccid_list = responseData.sims;
					})
					.catch((err) => console.log(err));
			},
			
			openModal(id) {
				this.showModal();
				this.board_id = id;
				this.imei = "";
				this.iccid_search = "";
				this.selectedIccid = null;
				this.showIccidSuggestions = false;
				this.filteredIccidList = [];
				this.device_model_id = "";
				this.fetchBatch();
				this.fetchDeviceModels();
			},

			closeModal() {
				this.hideModal();
			},

			// New Add Board Modal Methods
			openAddBoardModal() {
				this.clearAddBoardForm();
				const modal = new Modal(document.getElementById('addBoardModal'));
				modal.show();
			},

			closeAddBoardModal() {
				const modal = Modal.getInstance(document.getElementById('addBoardModal'));
				if (modal) {
					modal.hide();
				}
			},

			clearAddBoardForm() {
				this.newBoard = {
					vendor: "",
					count: 1,
					invoice_number: "",
					amount: "",
					notes: ""
				};
				this.errors = {};
			},

			saveBoard() {
				// Reset errors
				this.errors = {};
				
				// Validation
				if (!this.newBoard.vendor) {
					this.errors.vendor = "Vendor is required";
				}
				if (!this.newBoard.count || this.newBoard.count < 1) {
					this.errors.count = "Count must be at least 1";
				}
				
				// If there are errors, don't proceed
				if (Object.keys(this.errors).length > 0) {
					return;
				}
				
				// Here you would typically make an API call to save the board
				// For now, we'll just show a success message and close the modal
				this.$swal({
					icon: 'success',
					title: 'Success!',
					text: `Board added successfully for vendor ID: ${this.newBoard.vendor} with count: ${this.newBoard.count}`,
					showConfirmButton: true,
					confirmButtonText: 'OK',
					position: "center",
					timer: '',
					toast: false,
				}).then(() => {
					this.closeAddBoardModal();
					// Optionally refresh the boards list here
					// this.fetchBoards();
				});
			},

			addBoard() {

                this.getToken();
                this.errors = {};
				this.board_loading = true;
                const config = {
                    headers: {
                        "Content-type": "multipart/form-data",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                    },
                };

                let url = "staffs/addBoardData";  
                this.loading = true;

				// Validation for new fields
				if (!this.newBoard.vendor) {
					this.errors.vendor = "Vendor is required";
				}
				if (!this.newBoard.count || this.newBoard.count < 1) {
					this.errors.count = "Count must be at least 1";
				}
				if (!this.newBoard.invoice_number || String(this.newBoard.invoice_number).trim() === "") {
					this.errors.invoice_number = "Invoice number is required";
				}
				if (this.newBoard.amount === "" || this.newBoard.amount === null || this.newBoard.amount === undefined) {
					this.errors.amount = "Amount is required";
				} else {
					const amt = parseFloat(this.newBoard.amount);
					if (isNaN(amt) || amt < 0) {
						this.errors.amount = "Amount must be a valid number";
					}
				}

				if (Object.keys(this.errors).length > 0) {
					this.board_loading = false;
					this.loading = false;
					return;
				}

                let formData = new FormData();
                formData.append("vendor_id", this.newBoard.vendor);
                formData.append("count", this.newBoard.count);
				formData.append("invoice_number", String(this.newBoard.invoice_number).trim());
				formData.append("amount", String(this.newBoard.amount));
               
                    this.$axios
                    .post(url, formData, config)
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("", response.data.message, "success");
                        } else {
                            this.$swal("", response.data.message, "error");
                        }
						this.closeAddBoardModal();
                        this.clearForm();
                        this.fetchBoards(this.active_page_url);
						this.board_loading = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        console.log(error.response);
                        if (error.response) {
                            if (error.response.data.message) {
                                this.errors = error.response.data.message;
                                this.$swal("", error.response.data.message, "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
						this.board_loading = false;
                    });
            },

			clearForm() {
				this.edit = false;
                this.vendor = "";
				this.stock = "";
				this.imei = "";
				this.iccid_search = "";
				this.selectedIccid = null;
				this.showIccidSuggestions = false;
				this.filteredIccidList = [];
				this.device_model_id = "";
				this.firmware_version = "";
				this.modal_title = "Add Board";
				this.button_title = "Save";
				this.errors = {};
				this.closeModal();
				this.newBoard = {
					vendor: "",
					count: 1,
					invoice_number: "",
					amount: "",
					notes: ""
				};
			},

			searchIccid() {
				if (this.iccid_search.trim() === '') {
					this.filteredIccidList = [];
					this.showIccidSuggestions = false;
					return;
				}
				
				this.filteredIccidList = this.iccid_list.filter(iccid => 
					iccid.iccid.toLowerCase().includes(this.iccid_search.toLowerCase())
				);
				
				if (this.filteredIccidList.length > 0) {
					this.showIccidSuggestions = true;
				}
			},

			selectIccid(iccid) {
				this.selectedIccid = iccid;
				this.iccid_search = iccid.iccid;
				this.showIccidSuggestions = false;
			},

			hideIccidSuggestions() {
				setTimeout(() => {
					this.showIccidSuggestions = false;
				}, 200);
			},

			markBoardFirmwareSuccess()
			{
				this.getToken();
				this.errors = {};

				if (!this.device_model_id) {
					this.$swal("", "Please select a device model", "error");
					return;
				}
				if (!this.selectedIccid || !this.selectedIccid.iccid) {
					this.$swal("", "Please select an ICCID", "error");
					return;
				}
				if (!this.firmware_version) {
					this.$swal("", "Please select a firmware version", "error");
					return;
				}

				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
					},
				};

				let url = "staffs/boardFirmwareSuccess";  
				this.isSubmittingFirmwareSuccess = true;
				let formData = new FormData();
				formData.append("board_id", this.board_id);
				formData.append("device_model", this.device_model_id);
				formData.append("imei", this.imei);
				formData.append("iccid", this.selectedIccid.iccid);
				formData.append("firmware_version", this.firmware_version);

				this.$axios
				.post(url, formData, config)
				.then((response) => {
					if (response.data.status) {
						this.$swal("", response.data.message, "success");
						this.clearForm();
						this.closeModal();
						this.fetchBoards(this.active_page_url);
					} else {
						this.$swal("", response.data.message, "error");
					}
				})
				.catch((error) => {
					console.log(error);
					console.log(error.response);
					if (error.response) {
						if (error.response.data.message) {
							this.errors = error.response.data.message;
							this.$swal("", error.response.data.message, "error");
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", "Something went wrong", "error");
					}
				})
				.finally(() => {
					this.isSubmittingFirmwareSuccess = false;
				});
			},

			openFirmwareFailedModal(board) {
				this.failedBoardId = board.id;
				this.failedBoardImei = board.imei || "";
				this.failedIccidSearch = "";
				this.failedSelectedIccid = null;
				this.failedDeviceModelId = "";
				this.failedShowIccidSuggestions = false;
				this.failedFilteredIccidList = [];
				this.isSubmittingFirmwareFailure = false;
				if (this.deviceModels.length === 0) {
					this.fetchDeviceModels();
				}
				const modal = new Modal(document.getElementById('firmwareFailedModal'));
				modal.show();
			},

			closeFirmwareFailedModal() {
				const modal = Modal.getInstance(document.getElementById('firmwareFailedModal'));
				if (modal) {
					modal.hide();
				}
				this.failedBoardId = null;
				this.failedBoardImei = "";
				this.failedIccidSearch = "";
				this.failedSelectedIccid = null;
				this.failedDeviceModelId = "";
				this.failedShowIccidSuggestions = false;
				this.failedFilteredIccidList = [];
			},

			searchIccidFailed() {
				if (this.failedIccidSearch.trim() === '') {
					this.failedFilteredIccidList = [];
					this.failedShowIccidSuggestions = false;
					return;
				}
				this.failedFilteredIccidList = this.iccid_list.filter(iccid =>
					iccid.iccid.toLowerCase().includes(this.failedIccidSearch.toLowerCase())
				);
				if (this.failedFilteredIccidList.length > 0) {
					this.failedShowIccidSuggestions = true;
				}
			},

			selectIccidFailed(iccid) {
				this.failedSelectedIccid = iccid;
				this.failedIccidSearch = iccid.iccid;
				this.failedShowIccidSuggestions = false;
			},

			hideIccidSuggestionsFailed() {
				setTimeout(() => {
					this.failedShowIccidSuggestions = false;
				}, 200);
			},

			submitFirmwareFailure() {
				this.getToken();
				this.isSubmittingFirmwareFailure = true;

				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
					},
				};

				let formData = new FormData();
				formData.append("board_id", this.failedBoardId);
				formData.append("imei", this.failedBoardImei);
				if (this.failedSelectedIccid && this.failedSelectedIccid.iccid) {
					formData.append("iccid", this.failedSelectedIccid.iccid);
				}
				if (this.failedDeviceModelId) {
					formData.append("device_model", this.failedDeviceModelId);
				}

				this.$axios
					.post("staffs/boardFirmwareFailure", formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
							this.closeFirmwareFailedModal();
							this.fetchBoards(this.active_page_url);
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.isSubmittingFirmwareFailure = false;
					})
					.catch((error) => {
						console.log(error);
						this.isSubmittingFirmwareFailure = false;
						if (error.response && error.response.data && error.response.data.message) {
							this.$swal("", error.response.data.message, "error");
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			fetchBatch() {
				this.getToken();
				this.$axios
					.get("/staffs/fetchBatch", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						if (res.data.status && res.data.data) {
							this.currentBatch = res.data.data;
						} else {
							this.currentBatch = null;
						}
					})
					.catch((err) => {
						console.log(err);
						this.currentBatch = null;
					});
			},

			fetchDeviceModels() {
				this.getToken();
				this.$axios
					.get("/staffs/getDeviceModel", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						if (res.data.status && res.data.data) {
							this.deviceModels = res.data.data;
						} else {
							this.deviceModels = [];
						}
					})
					.catch((err) => {
						console.log(err);
						this.deviceModels = [];
					});
			},

			createNewBatch() {
				this.$swal({
					icon: "warning",
					title: "Confirm",
					text: "Are you sure you want to start a new batch?",
					showCancelButton: true,
					confirmButtonText: "Yes",
					confirmButtonColor: "#e64942",
					cancelButtonText: "No",
					position: "center",
					showConfirmButton: true,
					timer: "",
					toast: false,
					cancelButtonColor: "#efefef",
				}).then((result) => {
					if (!result.value) return;

					this.getToken();
					const config = {
						headers: {
							"Content-type": "multipart/form-data",
							"Accept": "application/json",
							"Authorization": "Bearer " + this.token,
						},
					};

					let url = "staffs/createBatch";
					this.loading = true;

					this.$axios
						.post(url, {}, config)
						.then((response) => {
							if (response.data.status && response.data.data) {
								this.currentBatch = {
									batch_number: response.data.data.batch_number,
									total_boards: 0
								};
								this.$swal("", "New batch created successfully", "success");
							} else {
								this.$swal("", response.data.message || "Failed to create batch", "error");
							}
							this.loading = false;
						})
						.catch((error) => {
							console.log(error);
							this.loading = false;
							if (error.response) {
								if (error.response.data.message) {
									this.$swal("", error.response.data.message, "error");
								} else {
									this.$swal("", "Something went wrong", "error");
								}
							} else {
								this.$swal("", "Something went wrong", "error");
						}
					});
				});
			},

			openUpdateSerialModal(board) {
				const modelId = board.model_id ?? board.device_model_id;
				this.selectedBoardForSerialUpdate = {
					id: board.id,
					imei: board.imei || "",
					serial_number: board.serial_number || "",
					device_model_id: modelId || null
				};
				this.serialUpdateDeviceModelId = modelId ? String(modelId) : "";
				this.serialSuffix = (board.serial_number && board.serial_number.length >= 7) ? board.serial_number.substring(7) : "";
				this.errors = {};
				if (this.deviceModels.length === 0) {
					this.fetchDeviceModels();
				}
				const modal = new Modal(document.getElementById('updateSerialModal'));
				modal.show();
			},

			closeUpdateSerialModal() {
				const modal = Modal.getInstance(document.getElementById('updateSerialModal'));
				if (modal) {
					modal.hide();
				}
				this.selectedBoardForSerialUpdate = {
					id: null,
					imei: "",
					serial_number: "",
					device_model_id: null
				};
				this.serialUpdateDeviceModelId = "";
				this.serialSuffix = "";
				this.errors = {};
			},

			updateSerialNumber() {
				this.getToken();
				this.errors = {};
				this.isSubmittingSerial = true;

				// Validation
				if (!this.serialUpdateDeviceModelId) {
					this.errors.serial_number = "Please select a device model";
					this.isSubmittingSerial = false;
					return;
				}
				const fullSerial = this.serialPrefix + (this.serialSuffix || "");
				if (!fullSerial.trim()) {
					this.errors.serial_number = "Serial number is required";
					this.isSubmittingSerial = false;
					return;
				}

				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
					},
				};

				let url = "staffs/updateSerialNumber";
				let formData = new FormData();
				formData.append("board_id", this.selectedBoardForSerialUpdate.id);
				formData.append("model_id", this.serialUpdateDeviceModelId);
				formData.append("serial_number", fullSerial.trim());

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message || "Serial number updated successfully", "success");
							this.closeUpdateSerialModal();
							this.fetchBoards(this.active_page_url);
						} else {
							this.$swal("", response.data.message || "Failed to update serial number", "error");
						}
						this.isSubmittingSerial = false;
					})
					.catch((error) => {
						console.log(error);
						this.isSubmittingSerial = false;
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},


		},
	};
</script>